export default "__VITE_ASSET__CiHJghPt__"